export const projectStatus = {
  Active: 1,
  OnHold: 2,
  Closed: 3
}

export const projectStatusList = [
  { id: projectStatus.Active, name: 'Active' },
  { id: projectStatus.OnHold, name: 'On-Hold' },
  { id: projectStatus.Closed, name: 'Closed' }
]
